(function () {
  'use strict';
  var root = document.getElementById('ym-quiz-v2');
  if (!root) return;

  var rawLoc = (root.dataset.locale || 'fr').toLowerCase();
  var loc = rawLoc.slice(0, 2);
  var LOC = (loc === 'en' || loc === 'de') ? loc : 'fr'; // quiz supported langs; es → fr
  var webhookUrl = root.dataset.webhookUrl || '';
  var gadsLead = (root.dataset.gadsLead || '').trim();   // libelle de conversion Google Ads (reglage de section)
  var previewUrl = root.dataset.previewUrl || '/pages/preview';

  // ============================================================
  //  i18n — all copy + lists for FR / EN / DE
  // ============================================================
  var I18N = {
    fr: {
      hook: "Votre extrait, 100% gratuit, sans paiement",
      privacy: "Vos réponses restent privées",
      back: "Retour", skip: "Passer", next: "Continuer", stepWord: "Étape", ofWord: "sur",
      ctaFinal: "🎁 Créer mon extrait gratuit",
      ctaNote: "Votre extrait arrive juste après. <b>Gratuit, sans paiement.</b>",
      submitting: "Création de votre extrait…",
      stepNames: ["Le destinataire", "Le style", "Sa personnalité", "Vos souvenirs", "Le mot du cœur", "Presque fini"],
      ask: {"wife": "Comment s'appelle votre femme ?", "husband": "Comment s'appelle votre mari ?", "girlfriend": "Comment s'appelle votre copine ?", "boyfriend": "Comment s'appelle votre copain ?", "mother": "Comment s'appelle votre mère ?", "father": "Comment s'appelle votre père ?", "child": "Comment s'appellent vos enfants ?", "friend": "Comment s'appelle votre ami(e) ?", "self": "Quel est votre prénom ?", "other": "Comment s'appelle cette personne ?"},
      s2_titlePre: "Quel style pour ",
      s2_titlePost: "&nbsp;?",
      s4_titlePre: "Vos plus beaux souvenirs avec ",
      s4_titlePost: "",
      s5_titlePre: "Un mot du cœur pour ",
      s5_titlePost: "&nbsp;?",
      occLabel: "À quelle occasion&nbsp;?", occOtherPh: "Précisez l'occasion…",
      occasions: [
        { em: "🎂", label: "Anniversaire" }, { em: "💍", label: "Mariage" }, { em: "👶", label: "Naissance" }, { em: "🌅", label: "Retraite" },
        { em: "🕊️", label: "Hommage" }, { em: "❤️", label: "Saint-Valentin" }, { em: "🌷", label: "Fête des mères / pères" }, { em: "🎄", label: "Noël" },
        { em: "✨", label: "Juste comme ça" }, { em: "✍️", label: "Autre" }
      ],
      diffLabel: "Une épreuve traversée ensemble&nbsp;?", diffPh: "Une maladie, la distance, un deuil… ce que vous avez surmonté à deux.",
      s1_eyebrow: "On commence", s1_title: "Pour qui est cette chanson&nbsp;?", s1_sub: "Parlez-nous de la personne qui compte.",
      nameLabel: "Son prénom", namePh: "Ex. Sophie", s1_errRecipient: "Choisissez pour qui est la chanson.", s1_errName: "Indiquez son prénom : il sera chanté dans le refrain.",
      recipients: [
        { key: "wife", em: "💍", label: "Ma femme", rel: "femme", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mon mari", rel: "mari", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Ma copine", rel: "copine", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mon copain", rel: "copain", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Ma mère", rel: "mère", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mon père", rel: "père", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Mes enfants", rel: "enfant", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Un(e) ami(e)", rel: "ami(e)", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Pour moi", rel: "moi", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Quelqu'un qui compte", rel: "personne qui compte", cat: "other", g: "n" }
      ],
      s2_eyebrow: "L'ambiance", s2_title: "Quel style pour la chanson&nbsp;?", s2_sub: "Choisissez le style qui colle à votre histoire.",
      topTag: "Top",
      stylesPop: ["Variété française", "Surprenez-moi", "Ballade romantique", "Country", "Pop", "Piano", "R&B", "Rock"],
      stylesExtra: ["Rap", "Soul", "Ouverture de bal / Mariage", "Oriental", "Latino", "Afro beats", "Métal", "Reggae", "Disco", "Classique", "Orchestre", "Autre"],
      moreStyles: "Plus de styles ▾", lessStyles: "Moins de styles ▴",
      voiceLabel: "La voix", voices: ["Chanteuse", "Chanteur", "Peu importe"],
      s3_eyebrow: "Sa personnalité", s3_titlePre: "Qu'est-ce qui rend ", s3_titleName: "cette personne", s3_titlePost: " unique&nbsp;?", s3_sub: "Touchez les mots qui lui ressemblent le plus.",
      qualities: ["Attentionné(e)", "Généreux(se)", "Drôle", "Doux(ce)", "Fort(e)", "Bienveillant(e)", "Passionné(e)", "Complice", "Courageux(se)", "Spontané(e)", "Fidèle", "Lumineux(se)"],
      qmoreLabel: "Vos propres mots", qmorePh: "Un trait bien à elle / à lui…", facult: "facultatif",
      s4_eyebrow: "Vos moments", s4_title: "Vos plus beaux souvenirs", memPh: "Le moment où…", memHint: "Pas sûr de quoi écrire ? Passez, on se débrouille avec le reste.",
      memSubs: {
        partner: "Votre histoire, vos complicités, les moments qui vous unissent.",
        parent: "Ce qu'il ou elle représente, les souvenirs, ce que vous lui devez.",
        child: "Les instants précieux, ce qui vous émeut chez lui ou elle.",
        other: "Les moments qui comptent, ce qui rend votre lien unique."
      },
      prompts: {
        partner: ["Notre rencontre…", "Un fou rire ensemble…", "Un moment qui compte…"],
        parent: ["Un souvenir d'enfance…", "Ce qu'il ou elle m'a appris…", "Une habitude qui vous fait sourire…"],
        child: ["Le jour de sa naissance…", "Un moment rien qu'à vous…", "Ce qui vous rend fier(e)…"],
        other: ["Comment vous vous êtes connus…", "Un souvenir marquant…", "Ce qui vous lie…"]
      },
      s5_eyebrow: "Le cœur", s5_title: "Un mot du cœur&nbsp;?", s5_sub: "Un message personnel que vous aimeriez retrouver dans la chanson.",
      msgPH: { f: "Je veux qu'elle sache que…", m: "Je veux qu'il sache que…", n: "Ce que j'aimerais lui dire, c'est…" },
      s6_eyebrow: "Dernière étape", s6_title: "Où envoie-t-on votre extrait&nbsp;?", s6_sub: "Un dernier mot pour le studio si vous voulez, puis votre email pour recevoir la chanson.",
      studioLabel: "Un mot pour le studio", studioPh: "Une envie, une chose à éviter, un détail qui compte…",
      emailLabel: "✉ Votre email", emailPh: "vous@exemple.fr",
      emailHint: "On vous envoie votre extrait ici, et il apparaît aussi sur cette page.",
      emailErr: "Votre email est nécessaire pour recevoir votre extrait.",
      trustRating: "4,9/5", trustCount: "plus de 21 000 chansons livrées",
      trustQuote: "« Elle a pleuré dès le refrain. Le plus beau cadeau que j'aie offert. »", trustAuthor: "Camille, offert à sa maman",
      reassure: ["Gratuit", "Sans carte bleue", "Modifications illimitées"],
      errGeneric: "Une erreur est survenue. Vérifiez votre connexion et réessayez."
    },
    en: {
      hook: "Free preview, no credit card required",
      privacy: "Your answers stay private",
      back: "Back", skip: "Skip", next: "Continue", stepWord: "Step", ofWord: "of",
      ctaFinal: "🎁 Create my free preview",
      ctaNote: "Your preview comes right after. <b>Free, no payment.</b>",
      submitting: "Creating your preview…",
      stepNames: ["The recipient", "The style", "Their personality", "Your memories", "A word from the heart", "Almost done"],
      ask: {"wife": "What's your wife's name?", "husband": "What's your husband's name?", "girlfriend": "What's your girlfriend's name?", "boyfriend": "What's your boyfriend's name?", "mother": "What's your mother's name?", "father": "What's your father's name?", "child": "What are your children's names?", "friend": "What's your friend's name?", "self": "What's your first name?", "other": "What's their name?"},
      s2_titlePre: "Which style for ",
      s2_titlePost: "?",
      s4_titlePre: "Your best memories with ",
      s4_titlePost: "",
      s5_titlePre: "A word from the heart for ",
      s5_titlePost: "?",
      occLabel: "What's the occasion?", occOtherPh: "Tell us the occasion…",
      occasions: [
        { em: "🎂", label: "Birthday" }, { em: "💍", label: "Wedding" }, { em: "👶", label: "Birth" }, { em: "🌅", label: "Retirement" },
        { em: "🕊️", label: "Tribute" }, { em: "❤️", label: "Valentine's Day" }, { em: "🌷", label: "Mother's / Father's Day" }, { em: "🎄", label: "Christmas" },
        { em: "✨", label: "Just because" }, { em: "✍️", label: "Other" }
      ],
      diffLabel: "A hard time you went through together?", diffPh: "An illness, distance, a loss… what you overcame together.",
      s1_eyebrow: "Let's start", s1_title: "Who is this song for?", s1_sub: "Tell us about the person who matters.",
      nameLabel: "Their first name", namePh: "e.g. Sophie", s1_errRecipient: "Please choose who the song is for.", s1_errName: "Please enter their first name: it will be sung in the chorus.",
      recipients: [
        { key: "wife", em: "💍", label: "My wife", rel: "wife", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "My husband", rel: "husband", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "My girlfriend", rel: "girlfriend", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "My boyfriend", rel: "boyfriend", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "My mother", rel: "mother", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "My father", rel: "father", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "My children", rel: "child", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "A friend", rel: "friend", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "For myself", rel: "myself", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Someone who matters", rel: "someone dear", cat: "other", g: "n" }
      ],
      s2_eyebrow: "The vibe", s2_title: "Which style for the song?", s2_sub: "Pick the style that fits your story.",
      topTag: "Top",
      stylesPop: ["Pop", "Surprise me", "Romantic Ballad", "Country", "Folk", "Piano", "R&B", "Rock"],
      stylesExtra: ["Rap / Hip-Hop", "Soul", "First Dance / Wedding", "Oriental", "Latin", "Afro Beats", "Metal", "Reggae", "Disco", "Classical", "Orchestra", "Other"],
      moreStyles: "More styles ▾", lessStyles: "Fewer styles ▴",
      voiceLabel: "The voice", voices: ["Female singer", "Male singer", "No preference"],
      s3_eyebrow: "Their personality", s3_titlePre: "What makes ", s3_titleName: "this person", s3_titlePost: " unique?", s3_sub: "Tap the words that fit them best.",
      qualities: ["Caring", "Generous", "Funny", "Gentle", "Strong", "Kind", "Passionate", "Close", "Brave", "Spontaneous", "Loyal", "Radiant"],
      qmoreLabel: "Your own words", qmorePh: "A trait that's truly theirs…", facult: "optional",
      s4_eyebrow: "Your moments", s4_title: "Your most precious memories", memPh: "The moment when…", memHint: "Not sure what to write? Skip it, we'll handle the rest.",
      memSubs: {
        partner: "Your story, your bond, the moments that unite you.",
        parent: "What they mean to you, the memories, what you owe them.",
        child: "The precious moments, what moves you about them.",
        other: "The moments that matter, what makes your bond unique."
      },
      prompts: {
        partner: ["How we met…", "A shared laugh…", "A moment that matters…"],
        parent: ["A childhood memory…", "What they taught me…", "A habit that makes you smile…"],
        child: ["The day they were born…", "A moment just for you two…", "What makes you proud…"],
        other: ["How you met…", "A memorable moment…", "What connects you…"]
      },
      s5_eyebrow: "The heart", s5_title: "A word from the heart?", s5_sub: "A personal message you'd like to hear in the song.",
      msgPH: { f: "I want her to know that…", m: "I want him to know that…", n: "What I'd like to tell them is…" },
      s6_eyebrow: "Last step", s6_title: "Where do we send your preview?", s6_sub: "One last word for the studio if you like, then your email to receive the song.",
      studioLabel: "A word for the studio", studioPh: "A wish, something to avoid, a detail that matters…",
      emailLabel: "✉ Your email", emailPh: "you@example.com",
      emailHint: "We send your preview here, and it also appears on this page.",
      emailErr: "Your email is required to receive your preview.",
      trustRating: "4.9/5", trustCount: "over 21,000 songs delivered",
      trustQuote: "“She cried at the very first chorus. The best gift I've ever given.”", trustAuthor: "Camille, for her mum",
      reassure: ["Free", "No credit card", "Unlimited revisions"],
      errGeneric: "Something went wrong. Check your connection and try again."
    },
    de: {
      hook: "Ihre Hörprobe, 100% kostenlos, ohne Zahlung",
      privacy: "Ihre Antworten bleiben privat",
      back: "Zurück", skip: "Überspringen", next: "Weiter", stepWord: "Schritt", ofWord: "von",
      ctaFinal: "🎁 Meine kostenlose Hörprobe erstellen",
      ctaNote: "Ihre Hörprobe kommt gleich danach. <b>Kostenlos, ohne Zahlung.</b>",
      submitting: "Ihre Hörprobe wird erstellt…",
      stepNames: ["Empfänger", "Der Stil", "Persönlichkeit", "Ihre Erinnerungen", "Ein Wort von Herzen", "Fast fertig"],
      ask: {"wife": "Wie heißt Ihre Frau?", "husband": "Wie heißt Ihr Mann?", "girlfriend": "Wie heißt Ihre Freundin?", "boyfriend": "Wie heißt Ihr Freund?", "mother": "Wie heißt Ihre Mutter?", "father": "Wie heißt Ihr Vater?", "child": "Wie heißen Ihre Kinder?", "friend": "Wie heißt Ihr Freund oder Ihre Freundin?", "self": "Wie heißen Sie?", "other": "Wie heißt diese Person?"},
      s2_titlePre: "Welcher Stil für ",
      s2_titlePost: "?",
      s4_titlePre: "Ihre schönsten Erinnerungen mit ",
      s4_titlePost: "",
      s5_titlePre: "Ein Wort von Herzen für ",
      s5_titlePost: "?",
      occLabel: "Zu welchem Anlass?", occOtherPh: "Welcher Anlass?…",
      occasions: [
        { em: "🎂", label: "Geburtstag" }, { em: "💍", label: "Hochzeit" }, { em: "👶", label: "Geburt" }, { em: "🌅", label: "Ruhestand" },
        { em: "🕊️", label: "Gedenken" }, { em: "❤️", label: "Valentinstag" }, { em: "🌷", label: "Mutter- / Vatertag" }, { em: "🎄", label: "Weihnachten" },
        { em: "✨", label: "Einfach so" }, { em: "✍️", label: "Andere" }
      ],
      diffLabel: "Eine schwere Zeit, die Sie gemeinsam durchgestanden haben?", diffPh: "Eine Krankheit, Entfernung, ein Verlust… was Sie zusammen überwunden haben.",
      s1_eyebrow: "Los geht's", s1_title: "Für wen ist dieses Lied?", s1_sub: "Erzählen Sie uns von der Person, die zählt.",
      nameLabel: "Ihr Vorname", namePh: "z.B. Sophie", s1_errRecipient: "Bitte wählen Sie, für wen das Lied ist.", s1_errName: "Bitte den Vornamen angeben: er wird im Refrain gesungen.",
      recipients: [
        { key: "wife", em: "💍", label: "Meine Frau", rel: "Frau", cat: "partner", g: "f" },
        { key: "husband", em: "🤵", label: "Mein Mann", rel: "Mann", cat: "partner", g: "m" },
        { key: "girlfriend", em: "💖", label: "Meine Freundin", rel: "Freundin", cat: "partner", g: "f" },
        { key: "boyfriend", em: "💙", label: "Mein Freund", rel: "Freund", cat: "partner", g: "m" },
        { key: "mother", em: "🌷", label: "Meine Mutter", rel: "Mutter", cat: "parent", g: "f" },
        { key: "father", em: "🌳", label: "Mein Vater", rel: "Vater", cat: "parent", g: "m" },
        { key: "child", em: "👶", label: "Meine Kinder", rel: "Kind", cat: "child", g: "n" },
        { key: "friend", em: "🤝", label: "Ein(e) Freund(in)", rel: "Freund(in)", cat: "other", g: "n" },
        { key: "self", em: "🎁", label: "Für mich", rel: "mich selbst", cat: "other", g: "n" },
        { key: "other", em: "✨", label: "Jemand Besonderes", rel: "besondere Person", cat: "other", g: "n" }
      ],
      s2_eyebrow: "Die Stimmung", s2_title: "Welcher Stil für das Lied?", s2_sub: "Wählen Sie den Stil, der zu Ihrer Geschichte passt.",
      topTag: "Top",
      stylesPop: ["Deutschpop", "Schlager", "Überrasche mich", "Romantische Ballade", "Pop", "Klavier", "R&B", "Rock"],
      stylesExtra: ["Rap", "Soul", "Eröffnungstanz / Hochzeit", "Orientalisch", "Latino", "Afrobeats", "Metal", "Reggae", "Disco", "Klassik", "Orchester", "Andere"],
      moreStyles: "Mehr Stile ▾", lessStyles: "Weniger Stile ▴",
      voiceLabel: "Die Stimme", voices: ["Sängerin", "Sänger", "Egal"],
      s3_eyebrow: "Persönlichkeit", s3_titlePre: "Was macht ", s3_titleName: "diese Person", s3_titlePost: " einzigartig?", s3_sub: "Tippen Sie auf die Wörter, die am besten passen.",
      qualities: ["Fürsorglich", "Großzügig", "Lustig", "Sanft", "Stark", "Gütig", "Leidenschaftlich", "Vertraut", "Mutig", "Spontan", "Treu", "Strahlend"],
      qmoreLabel: "Ihre eigenen Worte", qmorePh: "Eine ganz eigene Eigenschaft…", facult: "optional",
      s4_eyebrow: "Ihre Momente", s4_title: "Ihre schönsten Erinnerungen", memPh: "Der Moment, als…", memHint: "Unsicher, was Sie schreiben sollen? Überspringen Sie, wir kümmern uns um den Rest.",
      memSubs: {
        partner: "Ihre Geschichte, Ihre Verbundenheit, die Momente, die Sie vereinen.",
        parent: "Was er oder sie bedeutet, die Erinnerungen, was Sie ihm/ihr verdanken.",
        child: "Die kostbaren Momente, was Sie an ihm oder ihr bewegt.",
        other: "Die Momente, die zählen, was Ihre Verbindung einzigartig macht."
      },
      prompts: {
        partner: ["Wie wir uns trafen…", "Ein gemeinsames Lachen…", "Ein Moment, der zählt…"],
        parent: ["Eine Kindheitserinnerung…", "Was er/sie mir beigebracht hat…", "Eine Gewohnheit, die Sie lächeln lässt…"],
        child: ["Der Tag der Geburt…", "Ein Moment nur für Sie beide…", "Worauf Sie stolz sind…"],
        other: ["Wie Sie sich kennenlernten…", "Ein prägender Moment…", "Was Sie verbindet…"]
      },
      s5_eyebrow: "Das Herz", s5_title: "Ein Wort von Herzen?", s5_sub: "Eine persönliche Botschaft, die Sie im Lied hören möchten.",
      msgPH: { f: "Ich möchte, dass sie weiß, dass…", m: "Ich möchte, dass er weiß, dass…", n: "Was ich ihm/ihr sagen möchte, ist…" },
      s6_eyebrow: "Letzter Schritt", s6_title: "Wohin senden wir Ihre Hörprobe?", s6_sub: "Ein letztes Wort für das Studio, wenn Sie möchten, dann Ihre E-Mail für das Lied.",
      studioLabel: "Ein Wort für das Studio", studioPh: "Ein Wunsch, etwas zu vermeiden, ein wichtiges Detail…",
      emailLabel: "✉ Ihre E-Mail", emailPh: "sie@beispiel.de",
      emailHint: "Wir senden Ihre Hörprobe hierhin, sie erscheint auch auf dieser Seite.",
      emailErr: "Ihre E-Mail ist erforderlich, um Ihre Hörprobe zu erhalten.",
      trustRating: "4,9/5", trustCount: "über 21.000 gelieferte Lieder",
      trustQuote: "„Sie weinte schon beim Refrain. Das schönste Geschenk, das ich je gemacht habe.“", trustAuthor: "Camille, für ihre Mama",
      reassure: ["Kostenlos", "Ohne Kreditkarte", "Unbegrenzte Änderungen"],
      errGeneric: "Es ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut."
    }
  };
  var T = I18N[LOC];

  var DEFAULT_COUNTRY = { fr: { iso: 'FR', dial: '+33' }, en: { iso: 'GB', dial: '+44' }, de: { iso: 'DE', dial: '+49' } };

  // ============================================================
  //  State
  // ============================================================
  var MAX = 6, cur = 1;
  var token = 'p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  var eventId = 'lead_' + token;
  var A = {
    recipientKey: '', recipientLabel: '', cat: 'other', gender: 'n', name: '',
    style: '', styleOther: '', voice: '',
    qualities: [], qmore: '', memories: '', message: '', studio: '', email: '',
    occasion: '', occasionOther: '', difficulties: ''
  };

  // ============================================================
  //  Reprise apres actualisation
  // ============================================================
  // Les reponses restent dans le navigateur du visiteur, rien n est envoye ailleurs.
  var CLE_REPRISE = 'ym_extrait_v2';
  var DUREE_REPRISE = 7 * 24 * 60 * 60 * 1000;
  var minuteurReprise = null;

  function sauverProgression() {
    try {
      localStorage.setItem(CLE_REPRISE, JSON.stringify({ t: Date.now(), etape: cur, rep: A }));
    } catch (e) {}
  }
  function planifierSauvegarde() {
    clearTimeout(minuteurReprise);
    minuteurReprise = setTimeout(sauverProgression, 400);
  }
  function oublierProgression() {
    try { localStorage.removeItem(CLE_REPRISE); } catch (e) {}
  }

  // On ne recopie que des cles deja connues, et seulement si le type correspond. Une
  // sauvegarde laissee par une version precedente du quiz ne peut donc rien casser.
  function reprendreProgression() {
    var brut, d, k, v;
    try { brut = localStorage.getItem(CLE_REPRISE); } catch (e) { return; }
    if (!brut) return;
    try { d = JSON.parse(brut); } catch (e) { oublierProgression(); return; }
    if (!d || !d.rep || typeof d.t !== 'number' || Date.now() - d.t > DUREE_REPRISE) {
      oublierProgression(); return;
    }
    function type(x) { return Object.prototype.toString.call(x); }
    for (k in A) {
      if (!Object.prototype.hasOwnProperty.call(A, k)) continue;
      v = d.rep[k];
      if (v === undefined || v === null || type(v) !== type(A[k])) continue;
      A[k] = v;
    }
    A.name = nomPropre(A.name);
    var e = parseInt(d.etape, 10);
    if (e >= 1 && e <= MAX) cur = e;
  }

  // ============================================================
  //  Helpers
  // ============================================================
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function flatten(s) {
    return String(s == null ? '' : s).replace(/[\r\n]+/g, '. ').replace(/\s+/g, ' ').replace(/\\/g, '').replace(/"/g, "'").trim();
  }
  function emailOk(v) { v = (v || '').trim(); return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function q(sel) { return root.querySelector(sel); }

  // ============================================================
  //  Step markup builders
  // ============================================================
  function optBtn(label, em, extra) {
    return '<button type="button" class="ymq-opt"' + (extra || '') + ' aria-pressed="false">' +
      (em ? '<span class="ymq-em">' + em + '</span>' : '') + esc(label) + '</button>';
  }
  function chip(label, extra, mini) {
    return '<button type="button" class="ymq-chip"' + (extra || '') + ' aria-pressed="false">' + esc(label) +
      (mini ? '<span class="ymq-mini">' + esc(mini) + '</span>' : '') + '</button>';
  }
  // Un prenom, c est court et sur une seule ligne. Sans cette borne, un collage
  // se retrouve dans les paroles, dans les mails et sur la page d ecoute.
  var NOM_MAX = 40;
  function nomPropre(v) {
    return String(v == null ? '' : v).replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ').slice(0, NOM_MAX);
  }

  function nameEcho() { return A.name ? esc(A.name) : T.s3_titleName; }

  // Le libelle du champ prenom suit le destinataire choisi.
  function questionPrenom() {
    return (T.ask && T.ask[A.recipientKey]) || T.nameLabel;
  }

  function stepHTML(n) {
    if (n === 1) {
      var opts = T.recipients.map(function (r, i) {
        return optBtn(r.label, r.em, ' data-i="' + i + '"');
      }).join('');
      return '<p class="ymq-eyebrow">' + T.s1_eyebrow + '</p>' +
        '<h1>' + T.s1_title + '</h1><p class="ymq-sub">' + T.s1_sub + '</p>' +
        '<div class="ymq-grid" id="ymq-recipients">' + opts + '</div>' +
        '<div class="ymq-field"><label for="ymq-name" id="ymq-namelbl">' + esc(questionPrenom()) + '</label>' +
        '<input type="text" id="ymq-name" maxlength="40" value="' + esc(A.name) + '" placeholder="' + esc(T.namePh) + '"></div>' +
        '<p class="ymq-hint" id="ymq-s1-err" hidden></p>' +
        '<p class="ymq-lbl">' + T.occLabel + '</p>' +
        '<div class="ymq-chips" id="ymq-occasions">' + T.occasions.map(function (o) { return chip(o.em + ' ' + o.label, ' data-occ="' + esc(o.label) + '"'); }).join('') + '</div>' +
        '<div class="ymq-field" id="ymq-occ-other"' + (/autre|other|andere/i.test(A.occasion) ? '' : ' hidden') + '>' +
        '<input type="text" id="ymq-occother" value="' + esc(A.occasionOther) + '" placeholder="' + esc(T.occOtherPh) + '" maxlength="60"></div>';
    }
    if (n === 2) {
      var pop = T.stylesPop.map(function (s, i) { return chip(s, ' data-style="' + esc(s) + '"', i === 0 ? T.topTag : ''); }).join('');
      var extra = T.stylesExtra.map(function (s) { return chip(s, ' data-style="' + esc(s) + '"'); }).join('');
      var voices = T.voices.map(function (v) { return optBtn(v, '', ' data-voice="' + esc(v) + '" style="justify-content:center"'); }).join('');
      return '<p class="ymq-eyebrow">' + T.s2_eyebrow + '</p>' +
        '<h1>' + T.s2_titlePre + '<em>' + nameEcho() + '</em>' + T.s2_titlePost + '</h1><p class="ymq-sub">' + T.s2_sub + '</p>' +
        '<div class="ymq-chips" id="ymq-styles">' + pop + '</div>' +
        '<button type="button" class="ymq-more" id="ymq-more">' + T.moreStyles + '</button>' +
        '<div class="ymq-chips ymq-styles-extra" id="ymq-styles-extra" hidden>' + extra + '</div>' +
        '<p class="ymq-lbl">' + T.voiceLabel + '</p>' +
        '<div class="ymq-grid ymq-grid-3" id="ymq-voices">' + voices + '</div>';
    }
    if (n === 3) {
      var qs = T.qualities.map(function (v) { return chip(v, ' data-q="' + esc(v) + '"'); }).join('');
      return '<p class="ymq-eyebrow">' + T.s3_eyebrow + '</p>' +
        '<h1>' + T.s3_titlePre + '<em>' + nameEcho() + '</em>' + T.s3_titlePost + '</h1><p class="ymq-sub">' + T.s3_sub + '</p>' +
        '<div class="ymq-chips" id="ymq-qualities" data-multi>' + qs + '</div>' +
        '<div class="ymq-field"><label for="ymq-qmore">' + T.qmoreLabel + ' <span class="ymq-facult">' + T.facult + '</span></label>' +
        '<input type="text" id="ymq-qmore" value="' + esc(A.qmore) + '" placeholder="' + esc(T.qmorePh) + '"></div>';
    }
    if (n === 4) {
      var sub = T.memSubs[A.cat] || T.memSubs.other;
      var prompts = (T.prompts[A.cat] || T.prompts.other).map(function (p) {
        return '<button type="button" class="ymq-prompt" data-p="' + esc(p.replace('…', '')) + '">' + esc(p) + '</button>';
      }).join('');
      return '<p class="ymq-eyebrow">' + T.s4_eyebrow + '</p>' +
        '<h1>' + T.s4_titlePre + '<em>' + nameEcho() + '</em>' + T.s4_titlePost + '</h1><p class="ymq-sub">' + esc(sub) + '</p>' +
        '<div class="ymq-field"><textarea id="ymq-memories" placeholder="' + esc(T.memPh) + '">' + esc(A.memories) + '</textarea>' +
        '<div class="ymq-prompts">' + prompts + '</div>' +
        '<p class="ymq-hint">' + esc(T.memHint) + '</p></div>' +
        '<div class="ymq-field"><label for="ymq-diff">' + T.diffLabel + ' <span class="ymq-facult">' + T.facult + '</span></label>' +
        '<textarea id="ymq-diff" style="min-height:64px" placeholder="' + esc(T.diffPh) + '">' + esc(A.difficulties) + '</textarea></div>';
    }
    if (n === 5) {
      var ph = T.msgPH[A.gender] || T.msgPH.n;
      return '<p class="ymq-eyebrow">' + T.s5_eyebrow + '</p>' +
        '<h1>' + T.s5_titlePre + '<em>' + nameEcho() + '</em>' + T.s5_titlePost + '</h1><p class="ymq-sub">' + T.s5_sub + '</p>' +
        '<div class="ymq-field"><textarea id="ymq-message" placeholder="' + esc(ph) + '">' + esc(A.message) + '</textarea>' +
        '<p class="ymq-hint ymq-facult" style="margin-top:9px">' + T.facult + '</p></div>';
    }
    if (n === 6) {
      var reassure = T.reassure.map(function (r) { return '<span><span class="ymq-c">✓</span> ' + esc(r) + '</span>'; }).join('');
      return '<p class="ymq-eyebrow">' + T.s6_eyebrow + '</p>' +
        '<h1>' + T.s6_title + '</h1><p class="ymq-sub">' + T.s6_sub + '</p>' +
        '<div class="ymq-field"><label for="ymq-studio">' + T.studioLabel + ' <span class="ymq-facult">' + T.facult + '</span></label>' +
        '<textarea id="ymq-studio" style="min-height:64px" placeholder="' + esc(T.studioPh) + '">' + esc(A.studio) + '</textarea></div>' +
        '<div class="ymq-field"><label for="ymq-email">' + T.emailLabel + '</label>' +
        '<input type="email" id="ymq-email" value="' + esc(A.email) + '" placeholder="' + esc(T.emailPh) + '">' +
        '<p class="ymq-hint" id="ymq-email-hint">' + esc(T.emailHint) + '</p></div>' +
        '<div class="ymq-trust"><div class="ymq-stars"><span class="ymq-s">★★★★★</span> <b>' + T.trustRating + '</b> · ' + esc(T.trustCount) + '</div>' +
        '<p class="ymq-quote">' + esc(T.trustQuote) + '<span>' + esc(T.trustAuthor) + '</span></p>' +
        '<div class="ymq-reassure">' + reassure + '</div></div>';
    }
    return '';
  }

  // ============================================================
  //  Bindings after each render
  // ============================================================
  function bindStep(n) {
    if (n === 1) {
      var grid = q('#ymq-recipients');
      grid.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-opt'); if (!b) return;
        grid.querySelectorAll('.ymq-opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        var r = T.recipients[+b.dataset.i];
        A.recipientKey = r.key; A.recipientLabel = r.rel; A.cat = r.cat; A.gender = r.g;
        var lb = q('#ymq-namelbl'); if (lb) lb.textContent = questionPrenom();
      });
      var ni = q('#ymq-name');
      ni.addEventListener('input', function () {
        var v = nomPropre(ni.value);
        if (v !== ni.value) ni.value = v;
        A.name = v;
      });
      // restore selection
      if (A.recipientKey) grid.querySelectorAll('.ymq-opt').forEach(function (o) { if (T.recipients[+o.dataset.i].key === A.recipientKey) o.setAttribute('aria-pressed', 'true'); });
      // occasion (single choice, "Autre" reveals a text field)
      var og = q('#ymq-occasions'), oo = q('#ymq-occ-other'), oi = q('#ymq-occother');
      og.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-chip'); if (!b) return;
        og.querySelectorAll('.ymq-chip').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        A.occasion = b.dataset.occ; oo.hidden = !/autre|other|andere/i.test(A.occasion); if (!oo.hidden) oi.focus();
      });
      oi.addEventListener('input', function () { A.occasionOther = oi.value; });
      if (A.occasion) og.querySelectorAll('.ymq-chip').forEach(function (o) { if (o.dataset.occ === A.occasion) o.setAttribute('aria-pressed', 'true'); });
    } else if (n === 2) {
      var pop = q('#ymq-styles'), extra = q('#ymq-styles-extra');
      function pick(e) {
        var b = e.target.closest('.ymq-chip'); if (!b) return;
        [pop, extra].forEach(function (g) { g.querySelectorAll('.ymq-chip').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); });
        A.style = b.dataset.style; A.styleOther = /autre|other|andere/i.test(A.style) ? A.style : '';
      }
      pop.addEventListener('click', pick); extra.addEventListener('click', pick);
      q('#ymq-more').addEventListener('click', function () { extra.hidden = !extra.hidden; this.textContent = extra.hidden ? T.moreStyles : T.lessStyles; });
      var vg = q('#ymq-voices');
      vg.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-opt'); if (!b) return;
        vg.querySelectorAll('.ymq-opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        A.voice = b.dataset.voice;
      });
      if (A.style) { root.querySelectorAll('.ymq-chip').forEach(function (o) { if (o.dataset.style === A.style) o.setAttribute('aria-pressed', 'true'); }); }
      if (A.voice) { vg.querySelectorAll('.ymq-opt').forEach(function (o) { if (o.dataset.voice === A.voice) o.setAttribute('aria-pressed', 'true'); }); }
    } else if (n === 3) {
      var g = q('#ymq-qualities');
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-chip'); if (!b) return;
        var on = b.getAttribute('aria-pressed') === 'true'; b.setAttribute('aria-pressed', on ? 'false' : 'true');
        var v = b.dataset.q; var idx = A.qualities.indexOf(v);
        if (on) { if (idx > -1) A.qualities.splice(idx, 1); } else if (idx === -1) A.qualities.push(v);
      });
      A.qualities.forEach(function (v) { var b = g.querySelector('.ymq-chip[data-q="' + v.replace(/"/g, '') + '"]'); });
      g.querySelectorAll('.ymq-chip').forEach(function (o) { if (A.qualities.indexOf(o.dataset.q) > -1) o.setAttribute('aria-pressed', 'true'); });
      var qm = q('#ymq-qmore'); qm.addEventListener('input', function () { A.qmore = qm.value; });
    } else if (n === 4) {
      var ta = q('#ymq-memories'); ta.addEventListener('input', function () { A.memories = ta.value; });
      q('.ymq-prompts').addEventListener('click', function (e) {
        var b = e.target.closest('.ymq-prompt'); if (!b) return;
        var bout = String(b.dataset.p || '').replace(/[….]+$/, '').trim();
        ta.value = (ta.value ? ta.value.replace(/\s+$/, '') + '\n' : '') + bout + ' : ';
        A.memories = ta.value; ta.focus();
        try { ta.setSelectionRange(ta.value.length, ta.value.length); } catch (e) {}
      });
      var td = q('#ymq-diff'); td.addEventListener('input', function () { A.difficulties = td.value; });
    } else if (n === 5) {
      var ta2 = q('#ymq-message'); ta2.addEventListener('input', function () { A.message = ta2.value; });
    } else if (n === 6) {
      var st = q('#ymq-studio'); st.addEventListener('input', function () { A.studio = st.value; });
      var em = q('#ymq-email'); em.addEventListener('input', function () { A.email = em.value; });
    }
  }

  // ============================================================
  //  Render + navigation
  // ============================================================
  var host = q('#ymq-step'), fill = q('#ymq-fill'), pct = q('#ymq-pct'), stepLbl = q('#ymq-steplabel');
  var back = q('#ymq-back'), skip = q('#ymq-skip'), next = q('#ymq-next'), ctaNote = q('#ymq-ctanote'), privEl = q('#ymq-privacy');
  var skippable = { 4: true, 5: true };

  function render() {
    host.innerHTML = stepHTML(cur);
    bindStep(cur);
    var p = Math.round(cur / MAX * 100);
    fill.style.width = p + '%'; pct.textContent = p + '%';
    stepLbl.innerHTML = T.stepWord + ' ' + cur + ' ' + T.ofWord + ' ' + MAX + ' · ' + T.stepNames[cur - 1];
    if (privEl) privEl.hidden = (cur !== 1);
    back.hidden = cur === 1; skip.hidden = !skippable[cur];
    back.textContent = '← ' + T.back; skip.textContent = T.skip;
    if (cur < MAX) { next.innerHTML = T.next; ctaNote.hidden = true; }
    else { next.innerHTML = T.ctaFinal; ctaNote.hidden = false; }
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
  }

  function validateStep1() {
    var el = q('#ymq-s1-err');
    var msg = !A.recipientKey ? T.s1_errRecipient : (!A.name.trim() ? T.s1_errName : '');
    if (!msg) { if (el) el.hidden = true; return true; }
    if (el) { el.innerHTML = '<span class="ymq-err">' + esc(msg) + '</span>'; el.hidden = false; el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var ni = q('#ymq-name'); if (ni && A.recipientKey && !A.name.trim()) ni.focus();
    return false;
  }
  next.addEventListener('click', function () {
    if (cur === 1 && !validateStep1()) return;
    if (cur < MAX) { cur++; render(); return; }
    submit();
  });
  back.addEventListener('click', function () { if (cur > 1) { cur--; render(); } });
  skip.addEventListener('click', function () { if (cur < MAX && skippable[cur]) { cur++; render(); } });

  // ============================================================
  //  Submit → Capture webhook → redirect to preview
  // ============================================================
  function buildPayload() {
    var dc = DEFAULT_COUNTRY[LOC] || DEFAULT_COUNTRY.fr;
    var quals = A.qualities.slice();
    if (A.qmore.trim()) quals.push(A.qmore.trim());
    return {
      token: token, eventId: eventId, locale: rawLoc, submittedAt: new Date().toISOString(),
      source: 'free-preview-quiz', url: location.href, userAgent: (navigator && navigator.userAgent) || '',
      lead: {
        firstName: '', lastName: '', email: (A.email || '').trim().toLowerCase(),
        phone: '', phoneLocal: '', countryIso: dc.iso, countryDial: dc.dial, smsConsent: false
      },
      song: {
        recipientKey: A.recipientKey, recipientLabel: flatten(A.recipientLabel), recipientOther: '',
        recipientName: flatten(A.name), musicStyle: flatten(A.style), musicStyleOther: flatten(A.styleOther),
        voice: flatten(A.voice), occasion: flatten(A.occasionOther.trim() ? A.occasionOther : A.occasion), occasionOther: flatten(A.occasionOther),
        qualities: flatten(quals.join(', ')), memories: flatten(A.memories), difficulties: flatten(A.difficulties),
        message: flatten(A.message), studioNote: flatten(A.studio)
      }
    };
  }

  function fireLead(payload) {
    var lead = payload.lead || {};
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', {
          content_name: 'YourMelody Free Preview', content_category: 'free-song-quiz',
          currency: 'EUR', value: 0.00, em: (lead.email || '').toLowerCase().trim(), country: (lead.countryIso || '').toLowerCase()
        }, { eventID: payload.eventId });
      }
    } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { currency: 'EUR', value: 0.00, event_id: payload.eventId, method: 'free-preview-quiz' }); } catch (e) {}
    // Google Ads : conversion "Lead" (libelle saisi dans les reglages de la section), transaction_id = eventId pour le dedoublonnage
    try {
      if (typeof window.gtag === 'function' && gadsLead) {
        var sendTo = gadsLead.indexOf('AW-') === 0 ? gadsLead : ('AW-16882374071/' + gadsLead);
        window.gtag('event', 'conversion', { send_to: sendTo, value: 0.00, currency: 'EUR', transaction_id: payload.eventId });
      }
    } catch (e) {}
    try {
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'generate_lead', event_id: payload.eventId, lead_token: payload.token, lead_source: payload.source, lead_locale: payload.locale, lead_email: lead.email, currency: 'EUR', value: 0.00 });
    } catch (e) {}
  }

  function setEmailError(msg) {
    var hint = q('#ymq-email-hint'); var em = q('#ymq-email');
    if (em) { em.focus(); em.style.borderColor = '#C2410C'; }
    if (hint) hint.innerHTML = '<span class="ymq-err">' + esc(msg) + '</span>';
  }

  var submitting = false;
  function submit() {
    if (submitting) return;
    if (!emailOk(A.email)) { setEmailError(T.emailErr); return; }
    if (!webhookUrl) { setEmailError('Webhook URL not configured.'); return; }
    submitting = true;
    next.disabled = true; next.classList.add('ymq-loading'); next.innerHTML = T.submitting;

    var payload = buildPayload();
    var base = previewUrl.replace(/^\/\//, '/');
    var dest = base + (base.indexOf('?') > -1 ? '&' : '?') + 't=' + encodeURIComponent(token);
    try { var ptid = new URLSearchParams(location.search).get('preview_theme_id'); if (ptid) dest += '&preview_theme_id=' + encodeURIComponent(ptid); } catch (e) {}
    var rn = flatten(A.name); if (rn) dest += '&name=' + encodeURIComponent(rn); // lets the wait page greet the recipient instantly (no capture race)

    fetch(webhookUrl, {
      method: 'POST', mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (resp) {
      if (!resp.ok) throw new Error('Webhook ' + resp.status);
      fireLead(payload);
      oublierProgression();
      window.location.href = dest;
    }).catch(function (err) {
      console.error('[ym-quiz-v2] submit error', err);
      submitting = false; next.disabled = false; next.classList.remove('ymq-loading'); next.innerHTML = T.ctaFinal;
      setEmailError(T.errGeneric);
    });
  }

  // ============================================================
  //  Boot
  // ============================================================
  var hookEl = q('#ymq-hook'), ctaNoteEl = q('#ymq-ctanote');
  if (hookEl) hookEl.innerHTML = '<span class="ymq-heart">♡</span>' + esc(T.hook);
  if (privEl) privEl.innerHTML = '🔒 ' + esc(T.privacy);
  if (ctaNoteEl) ctaNoteEl.innerHTML = T.ctaNote;
  reprendreProgression();
  root.addEventListener('input', planifierSauvegarde);
  root.addEventListener('change', planifierSauvegarde);
  root.addEventListener('click', planifierSauvegarde);
  render();
  console.info('[ym-quiz-v2] init locale=' + LOC + ' token=' + token);

  // ============================================================
  //  ViewContent (Meta) — une seule fois par chargement de page
  // ============================================================
  // Evenement STANDARD, pas trackCustom : Meta n optimise que sur ses evenements
  // standards. Pas d eventID : aucun ViewContent n est emis cote serveur pour cette
  // page, il n y aurait rien a dedoublonner, et un identifiant reutilise d un
  // chargement a l autre ferait disparaitre les vues suivantes.
  (function vueContenu() {
    if (window.__ymViewContentPreview) return;
    window.__ymViewContentPreview = true;
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', {
          content_name: 'YourMelody Free Preview',
          content_category: 'free-song-quiz',
          currency: 'EUR',
          value: 0.00
        });
      }
    } catch (e) {}
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({ event: 'view_content', funnel: 'free-preview-v2', locale: rawLoc });
      }
    } catch (e) {}
  })();
})();
